// @ts-strict-ignore
import {Component, Input, TemplateRef, output} from "@angular/core";
import {TrackByMethods} from "@services";
import {Translations} from "@translations";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {AssessablePanelMode} from "@common/components/assessment/utils";

@Component({
	selector: "sim-single-choice-item",
	templateUrl: "./single-choice-item.component.html",
	styleUrls: ["./single-choice-item.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 250}), zoomOutOnLeaveAnimation({duration: 250})],
	standalone: false,
})
export class SingleChoiceItemComponent {
	// Enums
	protected readonly AssessablePanelMode = AssessablePanelMode;
	protected readonly TrackByMethods = TrackByMethods;
	protected readonly T = Translations;

	@Input({required: true}) mode: AssessablePanelMode = AssessablePanelMode.View;
	@Input({required: true}) item: {answer: any; options: string[]};
	@Input({required: true}) inEditMode = false;
	@Input({required: true}) optionTemplate: TemplateRef<any>;
	@Input() scoreTemplate: TemplateRef<any>;

	onRemoveOption = output<number>();
	onAddOption = output<void>();
	onUpdateAnswerSimple = output<number>();

	public handleRadioButtonChange(index: number) {
		if (this.mode === AssessablePanelMode.Answer) {
			this.onUpdateAnswerSimple.emit(index);
		}
	}

	public handleClick(index: number) {
		if (this.mode === AssessablePanelMode.Answer && index === this.item.answer) {
			this.onUpdateAnswerSimple.emit(index);
		}
	}
}
